import { Box, Stack, Typography, useTheme } from '@mui/material'
import { renderServiceIcon } from 'components/MetricAnalytics/renderServiceIcon'
import { ElementType } from 'react'
import BudgetSvg from '../../images/icons/budget.svg'
import DarkBudgetSvg from '../../images/icons/darkBudget.svg'

const renderBudgetIcons = (service, theme) => {
  switch (service) {
    case 'Management Fee / Retainer':
      return theme.palette.mode === 'dark' ? DarkBudgetSvg : BudgetSvg
    case 'Paid Search Management Fee':
      return theme.palette.mode === 'dark' ? DarkBudgetSvg : BudgetSvg
    case 'Paid Social Management Fee':
      return theme.palette.mode === 'dark' ? DarkBudgetSvg : BudgetSvg
    case 'Geofencing Advertising Management Fee':
      return theme.palette.mode === 'dark' ? DarkBudgetSvg : BudgetSvg
    case 'Video Management Fee':
      return theme.palette.mode === 'dark' ? DarkBudgetSvg : BudgetSvg
    case 'Programmatic Display Management Fee':
      return theme.palette.mode === 'dark' ? DarkBudgetSvg : BudgetSvg
    case 'Website Transfer Fee':
      return theme.palette.mode === 'dark' ? DarkBudgetSvg : BudgetSvg
    case 'Social Ads - Setup Fee':
      return theme.palette.mode === 'dark' ? DarkBudgetSvg : BudgetSvg
    case 'Setup Fee - Website/Creative':
      return theme.palette.mode === 'dark' ? DarkBudgetSvg : BudgetSvg
    case 'Setup Fee - Paid Media':
      return theme.palette.mode === 'dark' ? DarkBudgetSvg : BudgetSvg
    case 'SEO - Setup Fee':
      return theme.palette.mode === 'dark' ? DarkBudgetSvg : BudgetSvg
  }
}

const RenderServiceIcon = ({
  service,
  size,
  margin,
}: {
  service: string
  size?: {
    width?: number
    height?: number
    fontSize?: number
    marginLeft?: number
    whitespace?: string
    minWidth?: number
  }
  margin?: boolean
}) => {
  const theme = useTheme()
  const budgetServices = [
    'Management Fee / Retainer',
    'Paid Search Management Fee',
    'Paid Social Management Fee',
    'Geofencing Advertising Management Fee',
    'Video Management Fee',
    'Paid Search Management Fee',
    'Programmatic Display Management Fee',
    'Website Transfer Fee',
    'Social Ads - Setup Fee',
    'Setup Fee - Website/Creative',
    'Setup Fee - Paid Media',
    'SEO - Setup Fee',
  ]

  const icon = budgetServices.includes(service) ? renderBudgetIcons(service, theme) : renderServiceIcon(service)
  const isReactComponent = typeof icon === 'function' || (typeof icon === 'object' && icon?.$$typeof)
  const IconComponent = icon as ElementType

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={3}
      sx={{
        whiteSpace: size?.whitespace ?? 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        fontSize: size?.fontSize ?? 14,
        color: 'text.primary',
        minWidth: size?.minWidth ?? 0,
        width: '100%',
        marginLeft: size?.marginLeft ?? 0,
      }}
    >
      {isReactComponent ? (
        <Box component="span" sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
          <IconComponent sx={{ width: size?.width ?? 24, height: size?.height ?? 24, color: 'text.primary' }} />
        </Box>
      ) : (
        <img
          key={`${service}`}
          src={icon as string}
          alt={service}
          style={{ width: size?.width ?? 24, height: size?.height ?? 24, flexShrink: 0 }}
        />
      )}
      <Typography
        sx={{
          minWidth: 0,
          flex: '1 1 auto',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: size?.fontSize ?? 16,
          color: 'text.primary',
          width: '100%',
        }}
      >
        {service}
      </Typography>
      {margin && (
        <Typography
          sx={{
            whiteSpace: 'nowrap',
            fontWeight: 600,
            opacity: 0.85,
            width: '100%',
          }}
        >
          {`${margin}%`}
        </Typography>
      )}
    </Stack>
  )
}

export default RenderServiceIcon
